export default __webpack_public_path__ + "static/media/ic-chat.1be55bf3.svg";